<template>
  <div>
    <form action="" :class="['store_input', typeOfCommunication + '_input']">
      <label :for=typeOfCommunication>{{ title }}</label>
      <input :id=typeOfCommunication type="text"
             :class="[hasErrors && !!input? 'failed_sent' : 'success_sent']"
             v-model="input"
             @change="$emit('input', input)"
             :placeholder="placeholderText" @keyup="checkIfIsEmpty"/>
      <div class="success_sent_text" v-if="!!hasSuccess && !!input">
        {{ successText }}
      </div>
      <div class="failed_sent_text" v-else-if="!!hasErrors && !!input">
        {{ errorText }}
      </div>
    </form>
    <button v-if="hasSubmit" type=""
            :class="['sms_invite_btn', { deactivated: !input }]"
            @click.prevent="actionOnClick(input)">
      {{ submitText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'form-field',
  props: {
    title: String,
    typeOfCommunication: String,
    actionOnClick: Function,
    placeholderText: String,
    submitText: String,
    errorText: String,
    successText: String,
    hasErrors: Boolean,
    hasSuccess: Boolean,
    hasSubmit: { type: Boolean, default: true },
  },
  data() {
    return {
      input: '',
    };
  },
  methods: {
    checkIfIsEmpty() {
      if (!this.input) this.$emit('initiateValues');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/sharedcomponents/FormField.vue